import PhysicianAvatar from './assets/Physician-Icon.svg';
import moment from 'moment-timezone';

export const getImage = (path:string) => {
    if(path){
        return path;
    }
    else{
        return PhysicianAvatar;
    }
}

export const getTime = (postData:any) => {
    let post = moment(moment(postData).format('YYYY-MM-DD'), "YYYY-MM-DD");
    let now = moment().format('YYYY-MM-DD');
    let days = Math.abs(moment.duration(post.diff(now)).asDays());
    let timeZone = moment(postData).tz('America/Los_Angeles').format('z');  
    
    if (days === 0) {
      return moment(postData).zone(-60).format('HH:mm')+' '+timeZone;
    }
    else {
      return moment(postData).startOf('hour').fromNow();
    }
}

export const createDate = (value: Date) => {
  return moment(value).format('DD MMM YYYY');
}

export const sliceEmail = (email: string, len: number) => {
  return email.length > len 
  ? email.slice(0, len)+'...'
  : email;
};

export const changeCampaignType = (type: string) => {
  switch (type) {
      case 'Small Banner':
          return 'Medium Rectangle';
      case 'Big Banner':
          return 'Leaderboard';
      default:
          return type
  }
}

export const redirectOutside = (path: string) => {
  //eslint-disable-next-line
  location.href = path;
}

export const redirectToSso = (next?: string) => {
  //eslint-disable-next-line
  location.href = `/dovemed-sso/?next=${encodeURIComponent(next || window.location.href)}`;
};
